const KEY = 'amorium_search';

export function saveSearch(data) {
  try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch {}
}

export function loadSearch() {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || null; } catch { return null; }
}

export function toFutureDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d >= today ? d : null;
}
